import React, { useEffect, useRef, useState } from "react";
import "./VangalAboutStats.css";
import Aboutusimage from "../../Assets/about-vangal-farms.jpg"


export default function AboutUsVangal() {
  return (
    <section className="vangal-aboutus-section">

      {/* ============= Stats Section ============= */}
      <StatsSection />

      {/* ============= About Section ============= */}
      <div className="vangal-aboutus-container">

        <div className="vangal-aboutus-image-box anim anim-top">
          <img
            src={Aboutusimage}
            alt="Vangal About Visual"
            className="vangal-aboutus-image"
          />
        </div>

        <div className="vangal-aboutus-text-box">
          <h3 className="vangal-aboutus-heading anim anim-top">About Us</h3>

          <div className="vangal-aboutus-content anim anim-bottom">
            <p>
              Vangal Dairies was started in 1993 in a humble way as a milk
              distribution company at Chennai. Realising that quality can't be
              maintained without having your own manufacturing facility, the
              company set up a state-of-the-art dairy at Namakkal in 1998.
            </p>

            <p>
              The Managing Director, Lt. S. Balachandar, after 7 years of service
              as an officer in the Indian Navy, chose to become an entrepreneur.
              Strong values and discipline shaped his journey into the dairy
              industry along with support from his wife, Mrs. Vanitha Balachandar,
              a qualified nutritionist.
            </p>

            <p>
              His grandfather, Mr. Palanisamy, ran a successful butter & ghee
              business “Palani Vilas Ghee Store” in Trichy in the 1950s, making
              dairy a part of his legacy.
            </p>

            <p>
              Gopika Agro Product Pvt. Ltd., incorporated in 2013, later became
              an associate of Vangal Dairies. Despite many brands existing, there
              was a lack of products with authentic taste and human touch. This
              inspired the creation of premium dairy products under VANGAL and
              GOPIKA.
            </p>

            <p>
              Every product from our dairy is hygienically and artisanally made
              without artificial preservatives or flavouring agents. Ethical
              sourcing and adherence to industry standards define our quality.
            </p>

            <p>
              Gopika Agro Product Pvt. Ltd. is the perfect size—not too big, not
              too small. Each product is handcrafted with care. Be it butter,
              ghee, paneer or curds, we ensure the nostalgic taste of traditional
              homemade flavours.
            </p>
          </div><br />

                    <a href="/contact" className="vangal-aboutus-btn">
  Get in Touch
</a>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { id: 1, value: 31, label: "Years of Legacy (Since 1993)" },
    { id: 2, value: 2, label: "State-of-the-art Facilities" },
    { id: 3, value: 50, label: "Premium Dairy Products Daily" },
    { id: 4, value: 100, label: "Percent Natural & Preservative-Free" }
  ];

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) setInView(true);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <div className="vangal-aboutus-stats" ref={sectionRef}>
      {stats.map(item => (
        <CounterBox
          key={item.id}
          value={item.value}
          label={item.label}
          start={inView}
        />
      ))}
    </div>
  );
}

function CounterBox({ value, label, start }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let current = 0;
    const duration = 1500;
    const increment = value / (duration / 20);

    const counter = setInterval(() => {
      current += increment;
      if (current >= value) {
        clearInterval(counter);
        setCount(value);
      } else {
        setCount(Math.ceil(current));
      }
    }, 20);

    return () => clearInterval(counter);
  }, [start, value]);

  return (
    <div className="vangal-aboutus-stat-item">
      <h2 className="vangal-aboutus-stat-number">{count}+</h2>
      <p className="vangal-aboutus-stat-label">{label}</p>
    </div>
  );
}
